import { useDispatch } from 'react-redux'
import { TableList } from '../../Components/TableList/TableList'
import { setDestinationView } from '../../Store/InterfaceSlice'
import { type EnrichedCertificate } from '../../Store/DataSlice'
import { useLocalization } from '../../Hooks/useLocalization'

interface CertificateListProps {
  certificates: EnrichedCertificate[]
  isLoading: boolean
}

export function CertificateList({
  certificates,
  isLoading,
}: CertificateListProps) {
  const dispatch = useDispatch()
  const certificateStatusesLocalization = useLocalization(
    'certificate-statuses'
  )

  return (
    <TableList
      items={certificates}
      configurations={{
        uuid: {
          label: 'Uuid',
          show: false,
        },
        certificateNumber: {
          label: 'Certificaat nummer',
          show: true,
        },
        naceCodes: {
          label: 'NACE codes',
          show: false,
        },
        companyBranches: {
          label: 'companyBranches',
          show: false,
        },
        companyNames: {
          label: 'Onderneming(en)',
          show: true,
        },
        companyPostcodes: {
          label: 'Onderneming postcodes',
          show: false,
        },
        isGroupCertificate: {
          label: 'Is groep certificaat',
          show: false,
          getValue: (value) => ((value as boolean) ? '✔️' : '❌'),
        },
        certificateInstanceName: {
          label: 'Certificaat instantie',
          show: true,
        },
        certificateInstanceVatNumber: {
          label: 'Certificaat instantie',
          show: false,
        },
        calculatedStatus: {
          label: 'Status',
          show: true,
          getValue: (value) =>
            certificateStatusesLocalization.text(
              value as string,
              value as string
            ),
        },
        status: {
          label: 'Status',
          show: false,
        },
        type: {
          label: 'Type',
          show: true,
        },
        issueDate: {
          label: 'Uitgave datum',
          show: false,
        },
        validFrom: {
          label: 'Geldig van',
          show: false,
          getValue: (value) => new Date(value as number).toLocaleDateString(),
        },
        validUntil: {
          label: 'Geldig tot',
          show: false,
          getValue: (value) => new Date(value as number).toLocaleDateString(),
        },
        extendedUntil: {
          label: 'Verlengd tot',
          show: false,
          getValue: (value) => new Date(value as number).toLocaleDateString(),
        },
        scope: {
          label: 'Scope',
          show: true,
          getElementValue: (value) => {
            return (
              <span className="overflow-limited-text" title={value as string}>
                {value as string}
              </span>
            )
          },
        },
      }}
      localizationSection={'certificate'}
      getUniqueKey={(item) => item.uuid}
      onRowClick={(item) =>
        dispatch(
          setDestinationView({
            destinationView: 'certificate-detail',
            detailKey: item.uuid,
          })
        )
      }
      isLoading={isLoading}
    />
  )
}
